const service = [
    {
        id: 1,
        servicename: 'Firm Swedish',
        description: "Merging calming Swedish massage movements with gentle stone warmth, this distinctive therapy genuinely elevates massage sessions to tranquil levels of unprecedented remedial efficacy. Suitable for those experiencing stress or muscle discomfort, it offers a restorative and relaxing journey.",
        Price: '60 mins $100 | 90 mins $150',
        img: require('../../img/Services/Services1.png')
    },
    {
        id: 2,
        servicename: 'Hot Stone',
        description: "Combining soothing Swedish massage strokes and smooth stone's comforting heat, this unique treatment creates a harmonious blend elevating your massage experience to new relaxation and therapeutic effectiveness heights.",
        Price: '60 mins $100 | 90 mins $150',
        img: require('../../img/Services/Services2.png')
    },
    {
        id: 3,
        servicename: 'Rest & Relax',
        description: "This refined experience merges relaxing Swedish elements, hot stone warmth, and aromatic oils, forming an unmatched relaxation blend. Our adept therapists apply fluid strokes, releasing tension and preparing the mind and body for an ultimate relaxation odyssey.",
        Price: '90 mins $170',
        img: require('../../img/Services/Services3.png')
    },
    {
        id: 4,
        servicename: 'Deep Tissue',
        description: "Focused on alleviating deep muscle tension and untangling knots, this intensive massage utilizes specialized techniques and sustained pressure to penetrate deeper muscle and fascia layers, addressing specific problem areas and promoting well-being.",
        Price: '60 mins $110 | 90 mins $165',
        img: require('../../img/Services/Services4.png')
    },
    {
        id: 5,
        servicename: 'Thai Stretching & Deep Tissue',
        description: "Combining Thai stretches and deep tissue relief, this innovative massage enhances flexibility and joint mobility. Expert therapists initiate the session, releasing tension and promoting movement ease, differing from traditional Thai massage approaches.",
        Price: '60 mins $110 | 90 mins $165',
        img: require('../../img/Services/Services5.png')
    },
    {
        id: 6,
        servicename: 'Body Scrub & Massage',
        description: "This gentle scrub exfoliates, unveiling radiant, youthful skin layers beneath. Infused with Vitamin E, the nourishing blend renders the skin supremely soft, intensely moisturized, and resplendently glowing.",
        Price: '60 mins $110 | 90 mins $165',
        img: require('../../img/Services/Services6.png')
    },
    {
        id : 7,
        servicename: ' facial',
        description : "Reveal your skin's natural radiance with our rejuvenating facial treatment. Tailored to address individual skin concerns, this experience combines deep cleansing, gentle exfoliation, and hydrating serums to refresh and renew. Allow our skilled estheticians to pamper and nourish your skin, leaving it feeling soft, smooth, and revitalized. Step into a world of relaxation and emerge with a youthful, glowing complexion.",
        Price: '1 hour $100',
        img: require('../../img/Services/Services7.png')
    },
    {
        id : 8,
        servicename: 'Package facial and massage',
        description: "Indulge in our ultimate relaxation package, combining the benefits of a revitalizing facial with a soothing massage. Begin by rejuvenating your skin's natural glow, addressing unique skin needs with deep cleansing, exfoliation, and hydrating treatments. Follow this with a therapeutic massage tailored to melt away stress and muscle tension. Together, this luxurious duo offers a holistic experience, leaving you refreshed from head to toe and revealing a radiant, relaxed you.", 
        Price : '2 hours $180',
        img: require('../../img/Services/Services8.png'),
    }
];

export default service;
